import DeleteResourceInteractor from "../../core/interactor/app/crud/DeleteResourceInteractor";
import Constants from "../common/Constants";

export default class DeleteIndexTypeAttributesInteractor {
  private deleteResource: DeleteResourceInteractor;

  constructor({ deleteResource }: any) {
    this.deleteResource = deleteResource;
  }

  async execute(indexTypeAttributeId: number) {
    return this.deleteResource.execute(
      Constants.indexTypeAttributePath,
      indexTypeAttributeId
    );
  }
}
